document.querySelectorAll('[data-co-pdp-carousel]').forEach((root) => {
  const viewport = root.querySelector('[data-co-pdp-carousel-viewport]');
  const track = root.querySelector('[data-co-pdp-carousel-track]');
  const dotsWrap = root.querySelector('[data-co-pdp-carousel-dots]');
  if (!viewport || !track || !dotsWrap) return;

  const slides = Array.from(track.children);
  if (!slides.length) return;

  let index = 0;
  let perView = 1;
  const gap = 12;
  let touchStartX = 0;
  let touchStartY = 0;

  const isMobile = () => window.innerWidth < 750;

  const getPerView = () => {
    if (window.innerWidth >= 990) return Math.min(3, slides.length);
    if (window.innerWidth >= 750) return Math.min(2, slides.length);
    return 1;
  };

  const maxIndex = () => Math.max(0, slides.length - perView);

  const buildDots = () => {
    dotsWrap.innerHTML = '';
    const pages = Math.max(1, maxIndex() + 1);
    for (let i = 0; i < pages; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'co-pdp__customers-dot' + (i === index ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => {
        index = i;
        update();
      });
      dotsWrap.appendChild(dot);
    }
  };

  const update = () => {
    perView = getPerView();
    if (index > maxIndex()) index = maxIndex();

    if (isMobile()) {
      track.style.transform = 'none';
      const slide = slides[index];
      if (slide) {
        viewport.scrollTo({
          left: slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2,
          behavior: 'smooth',
        });
      }
    } else {
      viewport.scrollLeft = 0;
      const slideWidth = slides[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(-' + index * (slideWidth + gap) + 'px)';
    }

    buildDots();
  };

  viewport.addEventListener('scroll', () => {
    if (!isMobile()) return;
    const center = viewport.scrollLeft + viewport.clientWidth / 2;
    let closest = 0;
    let closestDist = Infinity;
    slides.forEach((slide, i) => {
      const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      const dist = Math.abs(center - slideCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    if (closest !== index) {
      index = Math.min(closest, maxIndex());
      buildDots();
    }
  }, { passive: true });

  viewport.addEventListener('touchstart', (event) => {
    if (!isMobile()) return;
    touchStartX = event.changedTouches[0].screenX;
    touchStartY = event.changedTouches[0].screenY;
  }, { passive: true });

  viewport.addEventListener('touchend', (event) => {
    if (!isMobile()) return;
    const touchEndX = event.changedTouches[0].screenX;
    const touchEndY = event.changedTouches[0].screenY;
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;
    if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

    if (deltaX > 0 && index < maxIndex()) {
      index += 1;
      update();
    } else if (deltaX < 0 && index > 0) {
      index -= 1;
      update();
    }
  }, { passive: true });

  window.addEventListener('resize', update);
  update();
});
